<div
  *hasRole="orgSaveImageRoles"
  class="downloadButton"
  [matTooltip]="'memoDetail.downloadImageTooltip' | translate"
  [matTooltipPosition]="'left'"
>
  @if (url != null) {
    <div
      class="imageDownloadButton noselect"
      (click)="markAsDownloaded($event)"
    >
      <a [href]="url" download target="_blank">
        <mat-icon>download</mat-icon>
      </a>
    </div>
  }
</div>
<ng-content> </ng-content>
